import React from 'react';
import ReactLoading from 'react-loading';

const Loader = ({ text = "Loading..." }) => {
  return (
    <div className="flex items-center justify-center h-full w-full p-4" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <ReactLoading type="spin" color="#8BC34A" height={50} width={50} />
      {text && (
        <div style={{ marginLeft: '20px', color: '#555', fontSize: '15px', fontWeight: 500 }}>
          {text}
        </div>
      )}
    </div>
  );
};

export default Loader;
